var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.799805,
    y: 0.0859375,
    width: 24.4,
    height: 17.4286,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_217_9728",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 25,
    height: 18
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.799805,
    y: 0.0859375,
    width: 24.4,
    height: 17.4286,
    rx: 4,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_217_9728)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6002 0.0859375H-0.799805V1.24784H23.6002V0.0859375ZM23.6002 2.40975H-0.799805V3.57165H23.6002V2.40975ZM-0.799805 4.73356H23.6002V5.89546H-0.799805V4.73356ZM23.6002 7.05737H-0.799805V8.21927H23.6002V7.05737ZM-0.799805 9.38118H23.6002V10.5431H-0.799805V9.38118ZM23.6002 11.705H-0.799805V12.8669H23.6002V11.705ZM-0.799805 14.0288H23.6002V15.1907H-0.799805V14.0288ZM23.6002 16.3526H-0.799805V17.5145H23.6002V16.3526Z",
    fill: "#D02F44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.799805,
    y: 0.0859375,
    width: 10.4571,
    height: 8.13333,
    fill: "#46467F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_217_9728)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.943257 2.40995C1.26411 2.40995 1.52421 2.14985 1.52421 1.829C1.52421 1.50815 1.26411 1.24805 0.943257 1.24805C0.622406 1.24805 0.362305 1.50815 0.362305 1.829C0.362305 2.14985 0.622406 2.40995 0.943257 2.40995ZM3.26707 2.40995C3.58792 2.40995 3.84802 2.14985 3.84802 1.829C3.84802 1.50815 3.58792 1.24805 3.26707 1.24805C2.94622 1.24805 2.68611 1.50815 2.68611 1.829C2.68611 2.14985 2.94622 2.40995 3.26707 2.40995ZM6.17183 1.829C6.17183 2.14985 5.91173 2.40995 5.59088 2.40995C5.27003 2.40995 5.00992 2.14985 5.00992 1.829C5.00992 1.50815 5.27003 1.24805 5.59088 1.24805C5.91173 1.24805 6.17183 1.50815 6.17183 1.829ZM7.91469 2.40995C8.23554 2.40995 8.49564 2.14985 8.49564 1.829C8.49564 1.50815 8.23554 1.24805 7.91469 1.24805C7.59383 1.24805 7.33373 1.50815 7.33373 1.829C7.33373 2.14985 7.59383 2.40995 7.91469 2.40995ZM2.68611 2.9909C2.68611 3.31175 2.42601 3.57186 2.10516 3.57186C1.78431 3.57186 1.52421 3.31175 1.52421 2.9909C1.52421 2.67005 1.78431 2.40995 2.10516 2.40995C2.42601 2.40995 2.68611 2.67005 2.68611 2.9909ZM4.42897 3.57186C4.74982 3.57186 5.00992 3.31175 5.00992 2.9909C5.00992 2.67005 4.74982 2.40995 4.42897 2.40995C4.10812 2.40995 3.84802 2.67005 3.84802 2.9909C3.84802 3.31175 4.10812 3.57186 4.42897 3.57186ZM7.33373 2.9909C7.33373 3.31175 7.07363 3.57186 6.75278 3.57186C6.43193 3.57186 6.17183 3.31175 6.17183 2.9909C6.17183 2.67005 6.43193 2.40995 6.75278 2.40995C7.07363 2.40995 7.33373 2.67005 7.33373 2.9909ZM7.91469 4.73376C8.23554 4.73376 8.49564 4.47366 8.49564 4.15281C8.49564 3.83196 8.23554 3.57186 7.91469 3.57186C7.59383 3.57186 7.33373 3.83196 7.33373 4.15281C7.33373 4.47366 7.59383 4.73376 7.91469 4.73376ZM6.17183 4.15281C6.17183 4.47366 5.91173 4.73376 5.59088 4.73376C5.27003 4.73376 5.00992 4.47366 5.00992 4.15281C5.00992 3.83196 5.27003 3.57186 5.59088 3.57186C5.91173 3.57186 6.17183 3.83196 6.17183 4.15281ZM3.26707 4.73376C3.58792 4.73376 3.84802 4.47366 3.84802 4.15281C3.84802 3.83196 3.58792 3.57186 3.26707 3.57186C2.94622 3.57186 2.68611 3.83196 2.68611 4.15281C2.68611 4.47366 2.94622 4.73376 3.26707 4.73376ZM1.52421 4.15281C1.52421 4.47366 1.26411 4.73376 0.943257 4.73376C0.622406 4.73376 0.362305 4.47366 0.362305 4.15281C0.362305 3.83196 0.622406 3.57186 0.943257 3.57186C1.26411 3.57186 1.52421 3.83196 1.52421 4.15281ZM2.10516 5.89567C2.42601 5.89567 2.68611 5.63556 2.68611 5.31471C2.68611 4.99386 2.42601 4.73376 2.10516 4.73376C1.78431 4.73376 1.52421 4.99386 1.52421 5.31471C1.52421 5.63556 1.78431 5.89567 2.10516 5.89567ZM5.00992 5.31471C5.00992 5.63556 4.74982 5.89567 4.42897 5.89567C4.10812 5.89567 3.84802 5.63556 3.84802 5.31471C3.84802 4.99386 4.10812 4.73376 4.42897 4.73376C4.74982 4.73376 5.00992 4.99386 5.00992 5.31471ZM6.75278 5.89567C7.07363 5.89567 7.33373 5.63556 7.33373 5.31471C7.33373 4.99386 7.07363 4.73376 6.75278 4.73376C6.43193 4.73376 6.17183 4.99386 6.17183 5.31471C6.17183 5.63556 6.43193 5.89567 6.75278 5.89567ZM8.49564 6.47662C8.49564 6.79747 8.23554 7.05757 7.91469 7.05757C7.59383 7.05757 7.33373 6.79747 7.33373 6.47662C7.33373 6.15577 7.59383 5.89567 7.91469 5.89567C8.23554 5.89567 8.49564 6.15577 8.49564 6.47662ZM5.59088 7.05757C5.91173 7.05757 6.17183 6.79747 6.17183 6.47662C6.17183 6.15577 5.91173 5.89567 5.59088 5.89567C5.27003 5.89567 5.00992 6.15577 5.00992 6.47662C5.00992 6.79747 5.27003 7.05757 5.59088 7.05757ZM3.84802 6.47662C3.84802 6.79747 3.58792 7.05757 3.26707 7.05757C2.94622 7.05757 2.68611 6.79747 2.68611 6.47662C2.68611 6.15577 2.94622 5.89567 3.26707 5.89567C3.58792 5.89567 3.84802 6.15577 3.84802 6.47662ZM0.943257 7.05757C1.26411 7.05757 1.52421 6.79747 1.52421 6.47662C1.52421 6.15577 1.26411 5.89567 0.943257 5.89567C0.622406 5.89567 0.362305 6.15577 0.362305 6.47662C0.362305 6.79747 0.622406 7.05757 0.943257 7.05757Z",
    fill: "url(#paint0_linear_217_9728)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_217_9728",
    x: 0.362305,
    y: 1.24805,
    width: 8.13379,
    height: 7.80859,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_217_9728"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_217_9728",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_217_9728",
    x1: 0.362305,
    y1: 1.24805,
    x2: 0.362305,
    y2: 7.05757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.e7a4a763a7c9024997c15a1d9670bf42.svg";
export { ForwardRef as ReactComponent };